import { safeGet } from '../functions';

export default (() => {
  const state = {};

  const createListener = vnode => (value) => {
    if (value === false) {
      const component = vnode.componentInstance.inputs
        .find(c => c.hasError || (Array.isArray(c.errorMessages) && c.errorMessages.length > 0));

      if (component) {
        component.$el.scrollIntoView({
          block: 'nearest',
          behavior: 'smooth',
        });
      }
    }
  };

  return {
    bind(el, binding, vnode) {
      if (process.env !== 'production' && safeGet(vnode, ['componentInstance', '$options', 'name']) !== 'v-form') {
        console.error(
          `Directive [${binding.rawName}] could be applied to [v-form] vuetify component only`,
        );
        return;
      }

      state.listener = createListener(vnode);
      vnode.componentInstance.$on('input', state.listener);
    },
    unbind(el, binding, vnode) {
      vnode.componentInstance.$off('input', state.listener);
    },
  };
})();
